import RemarksConfirmModal from "./RemarksConfirmModal";

/** Confirms completion of a lesson; the API is called only on "Done". */
const MarkCompleteModal = ({ lesson, isSubmitting, onClose, onSubmit }) => (
  <RemarksConfirmModal
    isOpen={Boolean(lesson)}
    title="Mark as Completed"
    message="You're about to mark this lesson plan as completed. Add your remarks below."
    label="Teacher Remarks"
    placeholder="Share how the lesson went, student engagement, what worked well..."
    isSubmitting={isSubmitting}
    onClose={onClose}
    onSubmit={onSubmit}
  />
);

export default MarkCompleteModal;
